import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { toast } from 'react-toastify';
import { CommonMinisterReligionCrumbs } from 'civil-status/constants/place';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import FormPlace from 'civil-status/components/place/form';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformRequest } from 'civil-status/utils/place';
import { DomainType } from 'civil-status/constants/domain';

const MinisterReligionNewPage = (): React.ReactElement => {
  const insertMinisterReligion = useHttpClient(`${__ACT_API_URL__}/valori-dominio-atti/insert`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues?: PlaceForm) => {
      const data = transformRequest(
        formValues,
        DomainType.MinisterReligion,
        DomainType.ReligiousCults
      );

      (
        insertMinisterReligion({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/ministro-culto');
      });
    },
    [insertMinisterReligion, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMinisterReligionCrumbs, { name: 'Nuovo ministro di culto' }]} />
      <FormPlace title="Inserimento ministro di culto" onSave={onSubmit} isMinisterReligion />
    </Fragment>
  );
};

MinisterReligionNewPage.displayName = 'Religious Cults new page component';

export default MinisterReligionNewPage;
